import { render, staticRenderFns } from "./EventRequest.vue?vue&type=template&id=585c4260&scoped=true&"
import script from "./EventRequest.vue?vue&type=script&lang=js&"
export * from "./EventRequest.vue?vue&type=script&lang=js&"
import style0 from "./EventRequest.vue?vue&type=style&index=0&id=585c4260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c4260",
  null
  
)

export default component.exports